import React__default from "react";
import { Icon } from "../../icon/icon/icon.mjs";
import { Image } from "../../image/image.mjs";
import { ObjectFit } from "../../object-fit/object-fit.mjs";
const ModalCover = (props) => {
  const BEM = () => {
    const classArray = ["modal__cover"];
    if (props.fillImage) {
      classArray.push("modal__cover--fill");
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  const CSS = () => {
    let styleEntities = {};
    if (props.minHeight) {
      styleEntities = {
        minHeight: "".concat(props.minHeight, "px")
      };
    }
    styleEntities.backgroundColor = props.backgroundColor;
    return styleEntities;
  };
  const iconCSS = () => {
    let styleEntities = {};
    if (props.iconMaxWidth) {
      styleEntities = {
        maxWidth: "".concat(props.iconMaxWidth, "px")
      };
    }
    styleEntities.color = props.iconColor;
    return styleEntities;
  };
  const getIcon = (icon) => {
    return /* @__PURE__ */ React__default.createElement(Icon, { ...icon, className: "modal__cover-icon", style: iconCSS() });
  };
  const getImage = (image) => {
    if (props.fillImage) {
      return /* @__PURE__ */ React__default.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center" }, /* @__PURE__ */ React__default.createElement(Image, { className: "modal__cover-image", ...image }));
    }
    return /* @__PURE__ */ React__default.createElement(Image, { className: "modal__cover-image", ...image });
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: BEM(), style: CSS() }, props.icon && getIcon(props.icon), props.image && getImage(props.image));
};
export {
  ModalCover
};
